export const REACT_API_KEY = "4Hu1n4FgqIaKDODxn6dpxLg6hiExQqIP0wPbf9Re";
export const SOCKET_SERVER_URL =
  "https://chat-app-backend-vz-051a5f838be5.herokuapp.com";
// export const SOCKET_SERVER_URL = "http://localhost:3001";
export const GREETING = "Welcome to the Chat Room";
export const HEADER = "Join Astro Talk 🌏";
export const HI = "Hi";
export const WELCOME_EMOJI = "!🌘";
